export default __webpack_public_path__ + "static/media/white_exchange.b168a0af.svg";